import {ReactElement} from 'react'
import {Trans, WithNamespaces, withNamespaces} from 'react-i18next'

import messages from '../../../../../assets/messages'
import UiNotification from '../../../../Common/UiNotification'

type FailedSubmitModalProps = WithNamespaces & {
  amountToWithdraw?: string,
  errorMessage: string | null,
  onClose: () => void,
}

function FailedSubmitModalBase(props: FailedSubmitModalProps): ReactElement {
  const {amountToWithdraw, errorMessage, onClose, t} = props

  const showAmountToWithdrawMessage = Number(amountToWithdraw) >= 0

  return (
    <UiNotification
      open={Boolean(errorMessage)}
      status="failure"
      type="payment"
      buttonMessage={t(messages.close.i18nKey, messages.close.defaults)}
      onClose={onClose}
    >
      {showAmountToWithdrawMessage ? (
        <Trans {...messages.withdrawalFailedSubmitted} values={{amountToWithdraw}} components={[<b>amountToWithdraw</b>]}/>
      ) : null}
      <div>({errorMessage})</div>
    </UiNotification>
  )
}

const FailedSubmitModal = withNamespaces()(FailedSubmitModalBase)

export {FailedSubmitModal}
